var moduleHelper = require('../../scripts/module-helper');

var maxSize = 5;

// the css is injected automatically
// require('css!modules/file/file.css');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// get the html for this module
var html = strip(require('raw!./file.html'));
var parsing = require('parsing').file;
var defaultRequired = false;

function parse(text, next) {
    strip(require('raw!./file.html'), function(outputHtml) {
        var match = parsing.parse(text);
        if (match) {
            text = text.replace(match[0], outputHtml);
        }
        next(text);
    });
};

function get(context) {
    var input = context.querySelector("input");
    return input;
}

function init(formRoot, meta, next) {
    var context = formRoot.querySelector('[data-module="file"]');
    if (context){
        context.addEventListener('change', validate.bind(this, context), true);
    }
    next(formRoot);
}

function validate(context, err) {

    var input = context.querySelector("input");
    var messagelabel = context.querySelector("#txt_file-error");
    var currentClasses = messagelabel.getAttribute("class") || "";

    // If no file has been chosen, we show this error
    if (!input.files || input.files.length === 0) {

        var message = document.createTextNode(context.getAttribute("data-msg-file-required"));

        messagelabel.innerHTML = "";
        messagelabel.appendChild(message);

        if (currentClasses.indexOf("error") === -1) {
            messagelabel.setAttribute("class", " error");
        }

    }

    var size = input.files && input.files[0] && input.files[0].size;
    var ok = size / 1024 / 1024 <= maxSize;

    if (!size && size !== 0) {
        return true;
    }

    if (!ok) {

        var message = document.createTextNode(context.getAttribute("data-msg-file-too-big"));

        messagelabel.innerHTML = "";
        messagelabel.appendChild(message);

        if (currentClasses.indexOf("error") == -1) {
            messagelabel.setAttribute("class", currentClasses + " error");
        }

    }
    else {
        currentClasses = currentClasses.replace(/(|\s)error(|\s)/g, "");
        messagelabel.setAttribute("class", currentClasses);

        var message = document.createTextNode(context.getAttribute("data-msg-valid"));
        messagelabel.innerHTML = "";
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " valid");
    }

    return ok;
}

function resetValidationState() {
    required = defaultRequired; // reset required flag
}

module.exports = {
    parse: parse,
    get: get,
    resetValidationState: resetValidationState,
    validate: validate,
    init: init
};




// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/file/file.js